import { Component, ViewChild, Output, Input, OnChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DxTagBoxComponent, DxTagBoxModule, DxValidatorModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
import { DxiValidationRuleModule } from 'devextreme-angular/ui/nested';

@Component({
    templateUrl: './weekday-selector.component.html',
    selector: 'ep-weekday-selector',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxTagBoxModule, FormsModule, DxValidatorModule, DxiValidationRuleModule]
})
export class WeekdaySelectorComponent implements OnChanges {
    public availableWeekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    selectedWeekdays: any[] = [];

    @Input() readonly: boolean;
    @Input() weekdays: string;
    @Input() requireSelection = false;
    @Output() weekdaysChange = new EventEmitter<string>();

    @ViewChild('weekdayPicker', { static: true })
    weekdayPicker: DxTagBoxComponent;

    ngOnChanges(changes: any) {
        if (changes.weekdays) {
            this.selectedWeekdays = this.weekdays
                .split(',')
                .map(day => day.trim())
                .filter(day => !!day)
                .map(day => this.availableWeekdays.find(e => e.localeCompare(day) === 0))
                .filter(day => !!day);
        }
    }

    onValueChanged(e: any) {
        this.weekdays = this.selectedWeekdays.join(', ');
        this.weekdaysChange.emit(this.weekdays);
    }

    // Validation only happens if enabled via component input parameter.
    hasSelectedWeekdays = (e: any): boolean => this.requireSelection ? e?.value?.length > 0 : true;
}
